import * as ScreenOrientation from 'expo-screen-orientation'
import { useCallback } from 'react'

export function useScreenOrientation() {
  const lockToPortrait = useCallback(async () => {
    try {
      await ScreenOrientation.lockAsync(
        ScreenOrientation.OrientationLock.PORTRAIT_UP,
      )
    } catch (error) {
      console.error('Erro ao travar orientação em retrato:', error)
      throw error
    }
  }, [])

  const lockToLandscape = useCallback(async () => {
    try {
      await ScreenOrientation.lockAsync(
        ScreenOrientation.OrientationLock.LANDSCAPE,
      )
    } catch (error) {
      console.error('Erro ao travar orientação em paisagem:', error)
      throw error
    }
  }, [])

  const unlockOrientation = useCallback(async () => {
    try {
      await ScreenOrientation.unlockAsync()
    } catch (error) {
      console.error('Erro ao destravar orientação:', error)
      throw error
    }
  }, [])

  const getOrientation = useCallback(async () => {
    try {
      const orientation = await ScreenOrientation.getOrientationAsync()
      return orientation
    } catch (error) {
      console.error('Erro ao obter orientação:', error)
      throw error
    }
  }, [])

  return {
    lockToPortrait,
    lockToLandscape,
    unlockOrientation,
    getOrientation,
  }
}
